import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShipmentsAdapter } from './shipments.adapter';
import { ShipmentsRequestConfig, ShipmentsStatusRequest } from '../../../../core/models/shipments.model';
import { ExcelDownload } from '../../../../core/models/excelDownload.model';
@Injectable({
  providedIn: 'root',
})
export class ShipmentsService {
  constructor(private shipmentsAdapter: ShipmentsAdapter) {}

  getShipments(shipmentsRequestConfig: ShipmentsRequestConfig): Observable<ShipmentsStatusRequest> {
    return this.shipmentsAdapter.getShipments(shipmentsRequestConfig);
  }

  exportShipments(shipmentsRequestConfig: ShipmentsRequestConfig): Observable<ExcelDownload> {
    return this.shipmentsAdapter.getShipmentsExport(shipmentsRequestConfig);
  };
}
